/* Project Import will be here */
import { post, IRequest } from "./index";
import { ISubmitCartApiInputParam } from "models/cartModels";
/* Project Import will be here */

export const submitCartApi = (data: ISubmitCartApiInputParam) => {
  const request: IRequest = { subUrl: `/SalesOrder/OrderSubmit`, data };
  return post(request);
};

/* Get the retailer current outstanding amount */
export const getRetailerOutstandingAmountApi = () => {
  const request: IRequest = { subUrl: `/Collection/Outstanding` };
  return post(request);
};

/* Clear cart */
export const clearCartApi = () => {
  const request: IRequest = { subUrl: `/SalesOrder/ClearCart` };
  return post(request);
};